<div class="order-listing-container">

    <!-- Filter Chips Section -->
    <div class="filter-chips-container">
        <div class="filter-chips">
            <button class="filter-chip all" [class.active]="isChipActive('all')" (click)="setFilter('all')">
                All <span class="chip-badge">{{ getFilterCount('all') }}</span>
            </button>
            <button class="filter-chip pending" [class.active]="isChipActive('pending')" (click)="setFilter('pending')">
                Pending <span class="chip-badge">{{ getFilterCount('pending') }}</span>
            </button>
            <button class="filter-chip successful" [class.active]="isChipActive('successful')"
                (click)="setFilter('successful')">
                Successful <span class="chip-badge">{{ getFilterCount('successful') }}</span>
            </button>
            <button class="filter-chip unsuccessful" [class.active]="isChipActive('unsuccessful')"
                (click)="setFilter('unsuccessful')">
                Unsuccessful <span class="chip-badge">{{ getFilterCount('unsuccessful') }}</span>
            </button>
            <button class="filter-chip cancelled" [class.active]="isChipActive('cancelled')"
                (click)="setFilter('cancelled')">
                Cancelled <span class="chip-badge">{{ getFilterCount('cancelled') }}</span>
            </button>
        </div>

        <div class="filter-actions">
            <!-- Refresh Button -->
            <button class="btn btn-secondary refresh-btn" (click)="refresh()" title="Refresh Orders">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                        d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                        clip-rule="evenodd" />
                </svg>
            </button>
            <!-- Beta Feedback Button -->
            <button class="btn btn-secondary feedback-btn" (click)="onBetaFeedback()" title="Give Feedback">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 00-1.032-.211 50.89 50.89 0 00-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 002.433 3.984L7.28 21.53A.75.75 0 016 21v-4.03a48.527 48.527 0 01-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979z" />
                    <path
                        d="M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 001.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0015.75 7.5z" />
                </svg>
                <span>Beta Feedback</span>
            </button>
            <button class="btn btn-secondary" (click)="clearFilters()">
                CLEAR FILTERS
            </button>
        </div>
    </div>

    <!-- Order Table Area -->
    <div class="table-wrapper" (scroll)="onTableScroll($event)">
        <table>
            <thead>
                <tr>
                    <th>Order ID</th>
                    <th>Company Info</th>
                    <th>Delivery Date</th>
                    <th>Committed Time</th>
                    <th>Driver</th>
                    <th>Status</th>
                    <th class="text-center">Actions</th>
                </tr>
            </thead>
            <tbody *ngIf="!isLoading || orders.length > 0">
                <tr *ngFor="let order of orders" (click)="goToOrderDetail(order)">
                    <td>
                        <div class="order-id">
                            <!-- Order Icon (D/P/W) -->
                            <div class="order-icon"
                                [class.pickup]="order.order_type === 'pickup' && order?.current_driver?.id"
                                [class.delivery]="order.order_type === 'delivery' && order?.current_driver?.id"
                                [class.warehouse]="order.order_type === 'warehouse' && order?.current_driver?.id">

                                <!-- ===== DELIVERY ===== -->
                                <ng-container *ngIf="order.order_type === 'delivery'">
                                    <!-- Assigned -->
                                    <div *ngIf="order?.current_driver?.id">D</div>
                                    <!-- Unassigned (Outline) -->
                                    <svg *ngIf="!order?.current_driver?.id" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24" fill="none" style="width: 20px; height: 20px;">
                                        <rect x="2" y="2" width="20" height="20" rx="4" stroke="#00a862"
                                            stroke-width="1" fill="none" />
                                        <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="700"
                                            fill="#00a862" font-family="Arial, sans-serif">D</text>
                                    </svg>
                                </ng-container>

                                <!-- ===== PICKUP ===== -->
                                <ng-container *ngIf="order.order_type === 'pickup'">
                                    <!-- Assigned -->
                                    <div *ngIf="order?.current_driver?.id">P</div>
                                    <!-- Unassigned (Outline) -->
                                    <svg *ngIf="!order?.current_driver?.id" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24" fill="none" style="width: 20px; height: 20px;">
                                        <rect x="2" y="2" width="20" height="20" rx="4" stroke="#DB2777"
                                            stroke-width="1" fill="none" />
                                        <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="700"
                                            fill="#DB2777" font-family="Arial, sans-serif">P</text>
                                    </svg>
                                </ng-container>
                            </div>

                            <div class="order-number-wrapper">
                                <span class="order-number-text">
                                    {{ order.parent_order == null ? (order.order_type == 'pickup' ? order.po :
                                    order.order_no) : order.order_no }}
                                </span>
                                <span class="order-hash" *ngIf="order.order_type === 'delivery' && order.po">
                                    {{ order.po }}
                                </span>
                                <span class="order-hash"
                                    *ngIf="order.order_type === 'pickup' && order.order_no && order.parent_order == null">
                                    {{ order.order_no }}
                                </span>
                            </div>

                            <!-- Multiple Order Indicator -->
                            <div *ngIf="order.multiple_order" class="circle">
                                <div class="inner-circle">
                                    <span>m</span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="customer-info">
                            <span class="customer-name">
                                {{ order.company_name || order.booked_in?.company_name }}
                            </span>
                            <span class="order-hash">
                                ({{ order.order_type === 'delivery' ? order.pickup_company_name :
                                order.dely_company_name }})
                            </span>
                        </div>
                    </td>
                    <td>{{ order.dely_date | date:'mediumDate' }}</td>
                    <td>{{ order.order_type === 'pickup' ? convertTime24To12(order.pickup_time) :
                        convertTime24To12(order.dely_time) }}</td>
                    <td>
                        <div class="driver-profile" *ngIf="order.current_driver?.id">
                            <div class="driver-name">
                                {{ order.current_driver?.first_name }} {{ order.current_driver?.last_name }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="eta-status-cell">
                            <span class="status-badge" [ngClass]="getStatusClass(order.order_status)">
                                {{ order.order_status | titlecase }}
                            </span>
                            <span *ngIf="shouldShowETA(order)" class="eta">ETA: {{ formatETDA(order.eta[0].etda)
                                }}</span>
                            <span *ngIf="shouldShowArrived(order)" class="eta">AT: {{ formatETDAs(order) }}</span>
                        </div>
                    </td>
                    <td class="actions-cell">
                        <button class="action-btn" title="View Detail"
                            (click)="goToOrderDetail(order); $event.stopPropagation()">
                            <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path fill-rule="evenodd"
                                    d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </td>
                </tr>
            </tbody>
            
            <!-- Skeleton Rows -->
            <tbody *ngIf="isLoading && orders.length === 0">
              <tr *ngFor="let item of [1,2,3,4,5,6,7,8,9,10]">
                <td><div class="skeleton-line full"></div></td>
                <td>
                  <div class="skeleton-line medium"></div>
                  <div class="skeleton-line small mt-2"></div>
                </td>
                <td><div class="skeleton-line small centered"></div></td>
                <td><div class="skeleton-line small centered"></div></td>
                <td><div class="skeleton-line medium"></div></td>
                <td><div class="skeleton-badge"></div></td>
                <td><div class="skeleton-action"></div></td>
              </tr>
            </tbody>
        </table>

        <!-- Empty State (Inside Wrapper) -->
        <div class="empty-state" *ngIf="orders.length === 0 && !isLoading">
            <svg width="64" height="64" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                    d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                    clip-rule="evenodd" />
            </svg>
            <p>No orders found</p>
            <button class="btn btn-primary" (click)="clearFilters()">Clear Filters</button>
        </div>


        <div class="loading-indicator" *ngIf="isLoading && orders.length > 0">
            <div class="loading-spinner"></div>
            <span>Loading more orders...</span>
        </div>
        <div class="table-scroll-spacer"></div>
    </div>
</div>
<!-- Footer Progress bar -->
<div class="table-footer" *ngIf="totalOrders > 0">
    <div class="pagination-info-group">
        <div class="pagination-info">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
          <path fill-rule="evenodd"
            d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clip-rule="evenodd" />
        </svg>
            {{ getPaginationInfo() }}
        </div>
        <div class="scroll-progress-bar">
            <div class="scroll-progress-fill" [style.width.%]="scrollProgress"></div>
        </div>
    </div>
</div>